"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
//
// utility
//
const RenderLogic_1 = require("../../RenderLogic");
//
// styles
//
const StyledText_1 = require("../StyledText");
const StyledDataRow_1 = require("../StyledDataRow");
const StyledColumnContainer_1 = require("../StyledColumnContainer");
// prettier-ignore
const statusMappings = {
    'available_for_pickup': 'Available for Pickup',
    'bad_tracking_code_error': 'Invalid Tracking Code',
    'cancelled': 'Cancelled',
    'delivered': 'Delivered',
    'error': 'Error',
    'failure': 'Failure to Deliver',
    'in_transit': 'In Transit',
    'out_for_delivery': 'Out for Delivery',
    'pending': 'Pending',
    'pre_transit': 'Pre-Transit',
    'return_to_sender': 'Return to Sender',
    'unknown': 'Unknown'
};
function renderStatus(status) {
    const statusString = statusMappings[status];
    return (react_1.default.createElement(StyledText_1.StyledText, { className: 'shipment-status' }, statusString || 'Unknown'));
}
function renderData(data) {
    let rowNum = 0;
    const dataMap = data.map((row) => {
        return (react_1.default.createElement(StyledDataRow_1.StyledDataRow, { key: rowNum++ },
            react_1.default.createElement(StyledColumnContainer_1.StyledColumnContainer, { left: true },
                (0, RenderLogic_1.renderTracking)(row),
                react_1.default.createElement(StyledText_1.StyledText, { className: 'carrier-name' }, row.carrierName)),
            react_1.default.createElement(StyledColumnContainer_1.StyledColumnContainer, null,
                renderStatus(row.status),
                (0, RenderLogic_1.renderArrival)(row.arrival))));
    });
    return react_1.default.createElement("div", null, dataMap);
}
const ModalTable = (props) => {
    return react_1.default.createElement("div", null, renderData(props.data));
};
exports.default = ModalTable;
